<div class="scratch-card-container">

  <button class="ACVTY-closebtn-chmp" (click)="popClosed()"><img src="assets/img/my-activity/ACVTY-cross-white.svg"
      class="ACVTY-closebtn-sicon" /> </button>
  <!-- <p (click)='resetCard()'>
  Start editing to see some magic happen :)
</p> -->
  <!-- {{percent}} -->
  <div class="scratch-wrapper" [ngStyle]="{'top': (showScratchMessage) ? '0' : '50%', 'pointer-events':(showScratchMessage) ? 'auto' : 'none' }">
    <div class="badge-img">
      <img src="{{selectedBadgeInfo?.badge.image}}" alt="Badge-img">
    </div>
    <div #canvas id="canvas-section">
    </div>
    <div class="scratchGuide" *ngIf="hideScratchGuide"><span>Scratch to Reveal</span></div>
  </div>
  <div class="message-section" [ngStyle]="{'display': (showScratchMessage) ? 'block' : 'none'}">
    <h3>Woohoo! <br /> You Have Earned A Badge</h3>

  </div>
</div>
